/**
 * 취급 제품 데이터 (홈페이지 제품 캐러셀용).
 *
 * 출처: 세이프락 도어락 특가 홍보지 + public/images/products/doorlock-image-sources.json.
 * 가격은 설치비 포함·현금가 기준이며 시세에 따라 변동될 수 있습니다.
 * 제품 이미지를 추가하면 이 배열에 항목을 넣기만 하면 캐러셀에 자동 반영됩니다.
 * 자세한 참고: docs/products-flyer.md
 */
export interface Product {
  id: number
  model: string
  brand: string
  /** 인증 방식 요약 (예: 번호+카드) */
  type: string
  /** 대표 뱃지 (지문/앱/푸시풀/무타공 등, 0~2개) */
  badges: string[]
  /** 설치비 포함·현금가 (원) */
  price: number
  features: string[]
  image: string
}

const IMG = '/images/products'

export const PRODUCTS: Product[] = [
  {
    id: 1,
    model: '락프로 H60N',
    brand: '락프로',
    type: '번호형',
    badges: ['보급형'],
    price: 90000,
    features: ['슬라이드 방식', '허수비밀번호', '이중잠금', '자동잠금', '화재대비기능'],
    image: `${IMG}/01-lockpro-h60n.png`,
  },
  {
    id: 2,
    model: '유니코 B200',
    brand: '유니코',
    type: '번호+카드',
    badges: ['즉시잠김'],
    price: 100000,
    features: ['슬라이드 방식', '허수비밀번호', '이중잠금', '자동·수동잠금', '화재대비기능'],
    image: `${IMG}/02-unicor-b200.png`,
  },
  {
    id: 4,
    model: '에버넷 LH310SN',
    brand: '에버넷',
    type: '번호+카드',
    badges: [],
    price: 110000,
    features: ['허수비밀번호', '이중잠금', '자동잠금', '원터치 방식', '화재대비기능'],
    image: `${IMG}/04-evernet-lh310sn.png`,
  },
  {
    id: 5,
    model: '유니코 T250',
    brand: '유니코',
    type: '번호+카드',
    badges: ['즉시잠김'],
    price: 115000,
    features: ['강압도난감지', '이중잠금', '자동잠금', '원터치 오픈', '전기충격방지', '화재대비기능'],
    image: `${IMG}/05-unicor-t250.png`,
  },
  {
    id: 6,
    model: '유니코 UR-550N',
    brand: '유니코',
    type: '번호형',
    badges: ['즉시잠김'],
    price: 115000,
    features: ['강압도난감지', '안내음성 지원', '원터치 오픈', '자동잠금', '전기충격방지', '화재대비기능'],
    image: `${IMG}/06-unicor-ur-550n.png`,
  },
  {
    id: 7,
    model: '에버넷 LH310H',
    brand: '에버넷',
    type: '번호+카드',
    badges: [],
    price: 120000,
    features: ['후크 강제잠금', '허수비밀번호', '이중잠금', '자동잠금', '화재대비기능'],
    image: `${IMG}/07-evernet-lh310h.png`,
  },
  {
    id: 8,
    model: '솔리티 TR700',
    brand: '솔리티',
    type: '번호+카드',
    badges: [],
    price: 120000,
    features: ['슬림 디자인', '허수비밀번호', '이중잠금', '자동잠금', '화재대비기능'],
    image: `${IMG}/08-solity-tr700.png`,
  },
  {
    id: 20,
    model: '에버넷 AK-S101P',
    brand: '에버넷',
    type: '번호+카드',
    badges: ['푸시풀', '무타공'],
    price: 150000,
    features: ['푸시풀 일체형', '무타공 설치', '내부이중잠금', '허수비밀번호', '전기충격방지', '화재대비기능'],
    image: `${IMG}/20-evernet-ak-s101p.png`,
  },
  {
    id: 21,
    model: '에버넷 L201P',
    brand: '에버넷',
    type: '번호+카드',
    badges: ['푸시풀', '무타공'],
    price: 155000,
    features: ['푸시풀 일체형', '무타공 설치', '내부이중잠금', '허수비밀번호', '전기충격방지', '화재대비기능'],
    image: `${IMG}/21-evernet-l201p.png`,
  },
  {
    id: 22,
    model: '솔리티 SP7000',
    brand: '솔리티',
    type: '번호+카드',
    badges: ['푸시풀', '앱'],
    price: 170000,
    features: ['0.5초 바로잠김', '파손감지', '허수비밀번호', '전기충격방지', '화재대비기능', '앱 지원(Kit 별매)'],
    image: `${IMG}/22-solity-sp7000.png`,
  },
  {
    id: 23,
    model: '코맥스 CDL-806MP',
    brand: '코맥스',
    type: '번호+카드',
    badges: ['무타공'],
    price: 175000,
    features: ['무타공 설치', '미니 주키', '허수비밀번호', '전기충격방지', '화재대비기능'],
    image: `${IMG}/23-commax-cdl-806mp.png`,
  },
  {
    id: 24,
    model: '유니코 TP-8510S',
    brand: '유니코',
    type: '번호+카드',
    badges: ['푸시풀', '즉시잠김'],
    price: 180000,
    features: ['매직넘버(허수조합)', '내부이중잠금', '허수비밀번호', '전기충격방지', '화재대비기능'],
    image: `${IMG}/24-unicor-tp8510s.png`,
  },
  {
    id: 25,
    model: '락프로 H5000SFH',
    brand: '락프로',
    type: '번호+카드+지문',
    badges: ['지문인식', '푸시풀'],
    price: 200000,
    features: ['지문인식', '무타공 설치', '이중잠금', '내부이중잠금', '전기충격방지', '화재대비기능', '리모컨(별매)'],
    image: `${IMG}/25-lockpro-h5000sfh.png`,
  },
  {
    id: 26,
    model: '솔리티 SP-4000',
    brand: '솔리티',
    type: '번호+카드',
    badges: ['푸시풀', '앱'],
    price: 210000,
    features: ['앱 원격제어', '내부이중잠금', '전기충격방지', '화재대비기능', '앱 지원(Kit 별매)'],
    image: `${IMG}/26-solity-sp4000.png`,
  },
]

/** 취급 브랜드 목록 (중복 제거, 등장 순서 유지) */
export const PRODUCT_BRANDS: string[] = PRODUCTS.reduce<string[]>((acc, p) => {
  if (!acc.includes(p.brand)) acc.push(p.brand)
  return acc
}, [])

/** 취급 브랜드 로고 (public/images/brands — 회색톤 필터로 표시) */
export const BRAND_LOGOS: { name: string; image: string }[] = [
  { name: '삼성', image: '/images/brands/삼성.png' },
  { name: '게이트맨', image: '/images/brands/게이트맨.webp' },
  { name: '솔리티', image: '/images/brands/솔리티.png' },
  { name: '에버넷', image: '/images/brands/에버넷.svg' },
  { name: '밀레시스텍', image: '/images/brands/밀레시스텍.svg' },
  { name: '직방', image: '/images/brands/직방.png' },
]

export function formatPrice(won: number): string {
  return won.toLocaleString('ko-KR')
}
